import { useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

export default function Toast({ message, variant = 'green', onDismiss }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 3000);
    return () => clearTimeout(t);
  }, [onDismiss]);

  const config = {
    green: { bg: 'linear-gradient(135deg,#059669,#10b981)', Icon: CheckCircle },
    red:   { bg: 'linear-gradient(135deg,#dc2626,#ef4444)', Icon: AlertCircle  },
    blue:  { bg: 'linear-gradient(135deg,#2563eb,#3b82f6)', Icon: Info         },
  };
  const { bg, Icon } = config[variant] || config.green;

  return (
    <div
      className="fixed bottom-6 right-6 z-[300] flex items-center gap-3 px-5 py-3.5 rounded-2xl text-white text-sm font-semibold shadow-2xl animate-slideUp"
      style={{ background: bg, minWidth: 240, maxWidth: 360 }}
    >
      <Icon className="w-4 h-4 flex-shrink-0" />
      <span className="flex-1">{message}</span>
      <button onClick={onDismiss} className="text-white/70 hover:text-white ml-2 flex-shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
